<template>
  <b-form-group label-cols="6" label-cols-lg="4" :label="label" label-for="input-st-date" :label-class="hideLabel" class="text-left mb-0">
    <b-input-group class="flex-no-wrap">
      <b-form-input :id="id" class="calculation-settings-input text-right" v-model="inputModel" :disabled="this.isDisabled" style="min-width: 2em"></b-form-input>
      <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" >
        <!-- :disabled="vectors.length == 0 || isDisabled"> -->
        <template slot="button-content"><i class="fas fa-sort-down" v-visible="this.showDropdown===true"></i></template>
        <b-dropdown-item
            v-for="vectorName of Array.from(this.vectors.keys())" :key="vectorName"
            @click='onClick({Name: vectorName, Value: vectors.get(vectorName)})'
        >{{ vectorName }}
        </b-dropdown-item>
      </b-dropdown>
    </b-input-group>
  </b-form-group>
</template>

<script>

export default {
  props: ["type", "id", "model", "vectors", "showHeader", "showDropdown", "isDisabled", "name", "unit"],
  data() {
    return {
      vectorName: ""
    }
  },
  computed: {
    inputModel: {
      get() {
        if (typeof (this.model) === 'object' && this.model.hasOwnProperty('Name')) { return this.model.Name; } else if (typeof (this.model) !== 'string' && typeof (this.model) !== 'number') { return this.model.join(', '); }
        return this.model;
      },
      set(val) {
        if (val != undefined && val != null && this.inputModel != val) { this.$emit(this.type + "VectorChange", val); }
      }
    },
    hideLabel() {
      return this.showHeader ? '' : 'hidden-label'
    },
    label() {
      let unit = this.unit != null ? this.unit : ' (%)';
      return this.showHeader ? this.name + ' ' + unit : ''
    }
  },
  methods:  {
    onClick(data) {
      this.vectorName = data.Name;
      this.inputModel = data;
    }
  }
}
</script>

<style lang="scss">
.toggle-class {
  padding-right: 0;
  padding-left: 0.5rem;

  i {
    font-size: 1rem !important;
    transform: translateY(-2px);
  }
}

.hidden-label {
  display: none;
}

.flex-no-wrap {
  flex-wrap: nowrap;
}
</style>

